import { API_URL } from 'consts/common.const';
import { Http } from 'services/http';

export interface UserRequest {
  email: string;
  empName: string;
  password: string;
  pathAvatar: string;
  send_email: boolean;
  phone: string;
  role: string | number;
  status: string | number;
  username: string;
  oldPassword: string;
  levelId: string | number;
  ownerId: number;
}

export const editUser = (userId, currentUrl, params: UserRequest) => {
  return Http.request({
    method: 'PUT',
    url: `${API_URL}/user/${userId}?currentUrl=${currentUrl}`,
    body: params,
  });
};
